import { ActionType } from '@/actions';
import { GameStep } from '@/config/game/steps';
import { ActionSetCurrentStep } from './interfaces';

export function setCurrentStep(
  game: number,
  value: GameStep
): ActionSetCurrentStep {
  return {
    type: ActionType.CURRENT_STEP_SET,
    game,
    value,
  };
}
